import { render, staticRenderFns } from "./AddAngularGaugeWidget.vue?vue&type=template&id=53efa75c"
import script from "./AddAngularGaugeWidget.vue?vue&type=script&lang=js"
export * from "./AddAngularGaugeWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports